export { default as withPayload } from './withPayload/withPayload.js'
